export const formatDate = (dateString) => {
  // If input is nullish, do nothing.
  if (!dateString) {
    return dateString;
  }
  const date = new Date(dateString);
  return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
};
